<template>
    <footer class="page-footer">
        <div
            :class="`content-box ${isMobile ? 'grid place-content-center' : 'flex justify-between'}`"
        >
            <!-- <div></div> -->
            <div :class="isMobile ? 'grid place-content-center' : ''">
                <a>
                    <img class="brand-logo-blank-desktop" :src="logo" alt="Engelink" />
                </a>
            </div>
            <div :class="isMobile ? 'grid place-content-center' : 'grid'">
                <span class="title-contact">Contatos</span>
                <span v-if="phoneRj" :class="isMobile ? 'text-sm' : ''">
                    <b>RJ</b>
                     - {{ phoneRj.phone }} 
                </span>
                <span v-if="phoneRs" :class="isMobile ? 'text-sm' : ''">
                    <b>RS</b>
                    - {{ phoneRs.phone }}
                </span>
                <span v-if="phoneSp" :class="isMobile ? 'text-sm' : ''">
                    <b>SP</b>
                    - {{ phoneSp.phone }}
                </span>
                <span v-if="phoneBa" :class="isMobile ? 'text-sm' : ''">
                    <b>BA</b>
                    - {{ phoneBa.phone }}
                </span>
            </div>
            <div :class="isMobile ? 'grid place-content-center' : 'grid pt-8'">
                <span v-if="phoneDf" :class="isMobile ? 'text-sm' : ''">
                    <b>DF</b>
                    - {{ phoneDf.phone }}
                </span>
                <span v-if="phoneMg" :class="isMobile ? 'text-sm' : ''">
                    <b>MG</b>
                    - {{ phoneMg.phone }}
                </span>
                <span v-if="phonePr" :class="isMobile ? 'text-sm' : ''">
                    <b>PR</b>
                    - {{ phonePr.phone }}
                </span>
                <span v-show="!isMobile">solicitacao@engelink.com.br</span>
            </div>
            <div :class="isMobile ? 'grid place-content-center' : ''">
                <span
                    :class="isMobile ? 'text-sm' : ''"
                    v-show="isMobile"
                >solicitacao@engelink.com.br</span>
            </div>
        </div>
        <div class="flex justify-center content-box">
            <div class="line mt-10 mb-5"></div>
        </div>
        <div class="flex justify-center content-box">
            <div
                class="copyright"
            >© Copyright 2021 | Todos Os Direitos Reservados | Desenvolvido Por Engelink</div>
        </div>
    </footer>
</template>

<script>
import { computed } from '@vue/composition-api';
import { getState } from '@/composibles/title-header';
export default {
    props: {
        isMobile: [Object, Boolean],
    },
    setup() {
        const logo = computed(() => require('@/assets/images/logo.png'));
        const phoneRj = computed(() => getState.state.phones.find((p) => p.state == 'RJ'));
        const phoneRs = computed(() => getState.state.phones.find((p) => p.state == 'RS'));
        const phoneSp = computed(() => getState.state.phones.find((p) => p.state == 'SP'));
        const phoneBa = computed(() => getState.state.phones.find((p) => p.state == 'BA'));
        const phoneDf = computed(() => getState.state.phones.find((p) => p.state == 'DF'));
        const phoneMg = computed(() => getState.state.phones.find((p) => p.state == 'MG'));
        const phonePr = computed(() => getState.state.phones.find((p) => p.state == 'PR'));

        return { logo, phoneRj, phoneRs, phoneSp, phoneBa, phoneDf, phoneMg, phonePr };        
    },
};
</script>
<style lang="scss" scoped>
.copyright {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
}
.line {
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.content-box {
    @apply container mx-auto px-8;
}
footer.page-footer {
    width: 100%;
    background-color: #0f2d53;
    color: #fff;
    padding-top: 65px !important;
    padding-bottom: 35px !important;
}
.brand-logo-blank-desktop {
    width: 113.05px;
    height: 25.74px;
}
.title-contact {
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
}
@media screen and (max-width: 992px) {
    footer.page-footer {
        padding-top: 35px !important;
    }
    .title-contact {
        padding-top: 30px;
        padding-bottom: 15px;
        display: grid;
        justify-content: center;
    }
    .copyright {
        width: 75%;
        text-align: center;
    }
}
</style>
